/* eslint-disable*/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'vi',
  lng: 'vi',
  resources: {
    vi: {
      translations: require('./locales/vi/translation.json'),
    },
    en: {
      translations: require('./locales/en/translation.json'),
    }
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

export default i18n;
